import React from 'react';
import { Spinner } from './ui/spinner';

interface BasicLoadingScreenProps {
  message?: string; // Kept for backward compatibility but not displayed
}

/**
 * BasicLoadingScreen - A simple, minimal loading screen with just a spinner
 * Used for secondary loading states (route guards, redirects, etc.)
 * to maintain consistency when multiple loading states occur in sequence
 */
export default function BasicLoadingScreen({ message }: BasicLoadingScreenProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <Spinner size="lg" className="text-blue-600" />
    </div>
  );
}
